import SavedStructure from "../../Constants/SavedStructure"; // Import structure

export const fetchSavedPosts = async () => {
  try {
    const response = await fetch("/api/mock/AccountPage/UserAccountSavedContentMockapi.json");
    const data = await response.json();

    // Safely extract posts array
    const postsArray = data?.posts || [];

    // Format each post according to SavedStructure
    const formattedPosts = postsArray.map((post) => ({
      postId: post?.postId || "",
      userId: post?.userId || post?.userid || "", // handles mismatch
      useruuid: post?.useruuid || "",
      userName: post?.userName || "",
      userimage: post?.userimage || "",
      profileId: post?.profileId || "",
      descriptions: post?.descriptions || "",
      timestamp: post?.timestamp || "",
      location: post?.location || "",
      medias: (post?.medias || []).map((media) => ({
        mediatype: media?.mediatype || "",
        mediaurl: media?.mediaurl || "",
      })),
    }));

    // Wrap in structure so it matches SavedStructure
    return {
      ...SavedStructure,
      posts: formattedPosts,
    };
  } catch (error) {
    console.error("Error fetching saved posts:", error);

    // Return an empty structure if something goes wrong
    return {
      ...SavedStructure,
      posts: [],
    };
  }
};
